import * as React from 'react';
import styled from 'styled-components';

type Props = {
  src: string;
  size?: string;
  position?: string;
  repeat?: string;
  color?: string;
};

const Image = styled.div<Props>(
  ({
    src,
    size = 'contain',
    position = 'center',
    repeat = 'no-repeat',
    color = '',
  }) => ({
    height: '100%',
    width: '100%',
    backgroundImage: `url("${src}")`,
    backgroundSize: size,
    backgroundRepeat: repeat,
    backgroundPosition: position,
    backgroundColor: color,
  })
);

const BackgroundImage: React.FC<Props> = ({
  src,
  size,
  position,
  repeat,
  color,
}) => {
  return (
    <Image
      src={src}
      size={size}
      position={position}
      repeat={repeat}
      color={color}
    />
  );
};

export default BackgroundImage;
